/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { getAssetHostURL, getIconPath, routerPush } from '@tcp/core/src/utils';
import { getAPIConfig } from '@tcp/core/src/utils/utils';
import AnimatedSearchIcon from '@tcp/web/src/components/common/atoms/AnimatedSearchIcon';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore.js';
import DiscoveryButton from '@tcp/web/src/components/common/vendors/Syte/DiscoveryButton';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { globalCommonBrowseLabels } from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { globalSortingLabels } from '@tcp/core/src/utils/labels/globalSorting.labels';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import { QVEcommerceCall } from '../../CategoryListingPage/container/analyticsHelper';
import ColorSwatchesHlp from './ColorSwatchesHlp';
import getColorSwatchList from './plpTileHelpers/colorSwatchHelper';
import getImageData from './plpTileHelpers/imageDataHelper';
import getPlpTileBadges from './plpTileHelpers/plpTileBadgesHelper';
import {
  extractBaseUrl,
  getImageAssetConfig,
  getPdpUrl,
  getPlpProductBrand,
  getProductDataForPdp,
  isBundleProduct,
  triggerOneClickATC,
} from './plpTileHelpers/plpTileCommonHelpers';
import getReviewRatingsData from './plpTileHelpers/reviewRatingsHelper';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import PriceAndWishList from './PriceAndWishList';
import ProductImage from './ProductImage';
import ProductTitleHlp from './ProductTitleHlp';
import ReviewAndratingsHlp from './ReviewAndRatingsHlp';
import style, { ColorSwatchWrapper, Divider, PlpTile } from './styles/PlpTile.style';
import { AtbIcon, SubmitButton } from './styles/SubmitButton.style';
import InfluencerBadgeHandle from '../../../../common/atoms/InfluencerBadgeHandle/view/InfluencerBadgeHandle';
import { getInfluencerTags } from '../../../../../services/abstractors/productListing/productParser';
import { memoizeTileData } from './plpTileHelpers/cacheHelper';

const colorSwatchCls = (flag) => {
  return flag ? 'color-swatch-class' : '';
};

// eslint-disable-next-line complexity
function HlpTileView(props) {
  const globalBrowseLabels = getLabelFromCopyOrFromTranslation(
    'global.CommonBrowseLabels',
    globalCommonBrowseLabels
  );

  const bestSellerBadgeLabel = renderLabel(globalBrowseLabels.lbl_best_seller, 'lbl_best_seller');

  const shopSimilarLabel = renderLabel(globalBrowseLabels.lbl_shop_similar, 'lbl_shop_similar');

  const topRatedBadgeLabel = getLabelFromCopyOrFromTranslation(
    'global.Sorting.lbl_TCPBazaarVoiceRating',
    globalSortingLabels
  );

  const plpTileLabels = getLabelFromCopyOrFromTranslation('PLP.plpTiles', PLPLabels);

  const pickupInStore = renderLabel(
    plpTileLabels.lbl_plp_pickup_in_store,
    'lbl_plp_pickup_in_store'
  );

  const shopTheLook = renderLabel(
    plpTileLabels.lbl_plpTiles_shop_the_look,
    'lbl_plpTiles_shop_the_look'
  );

  const shopCollection = renderLabel(
    plpTileLabels.lbl_plpTiles_shop_collection,
    'lbl_plpTiles_shop_collection'
  );
  const {
    className,
    pathName,
    customClass,
    tileData,
    tileActions,
    wishListData,
    submitButtonText,
    isShortImage,
    isLoggedIn,
    trackWishListClick,
    saveProductDataForPdp,
    saveProductDataForQV,
    categoryName,
    isTopRatedBackAbEnabled,
    isBestSellerBackAbEnabled,
    isSyteEnabled,
    trackAnalyticsClick,
    addToBagIconInPLP,
    isNewSwatchUrlEnabled,
    preloadImage,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    isInfluencerBadgeEnabled,
    isTileRedesignAB,
    promotionsData,
  } = props;

  const hasMounted = useHasMounted();
  let isMountedTileRedesignAB = 'variationA';
  if (hasMounted && isTileRedesignAB === 'variationB') {
    isMountedTileRedesignAB = 'variationB';
  }
  if (hasMounted && !isTileRedesignAB) {
    isMountedTileRedesignAB = false;
  }

  if (!tileData) return null;
  const {
    prodpartno: productPartNo,
    style_partno: stylePartNo,
    seo_token: seoToken,
    product_name: productName,
    min_list_price: minLP,
    min_offer_price: minOP,
    low_offer_price: lowOfferPrice,
    high_offer_price: highOfferPrice,
    low_list_price: lowListPrice,
    high_list_price: highListPrice,
    TCPSwatchesUSStore,
    TCPSwatchesCanadaStore,
    TCPBazaarVoiceRating,
    TCPBazaarVoiceReviewCount,
    productimage: imageName,
    alt_img: altImage,
    TCPStyleQTYCA,
    TCPStyleQTYUS,
    TCPStyleTypeCA,
    TCPStyleTypeUS,
    swatchimage: swatchImg,
    related_product_swatch_images: relatedSwatches,
    TCPColor: tcpColor,
    TCPCustomSalePrice,
    TCPCustomListPrice,
  } = tileData;

  const minListPrice = TCPCustomListPrice || minLP;
  const minOfferPrice = TCPCustomSalePrice || minOP;

  const styleTypeQty = {
    TCPStyleQTYCA,
    TCPStyleQTYUS,
    TCPStyleTypeCA,
    TCPStyleTypeUS,
  };
  const [showDiscoveryIcon, setShowDiscoveryIcon] = useState(false);
  const relatedSwatchImages = (relatedSwatches && relatedSwatches.split(',')) || [];
  const { onQuickViewOpenClick, onAddItemToFavorites, onSetLastDeletedItemIdAction, addToBagEcom } =
    tileActions;
  const commonCacheKeys = { pathName, productId: productPartNo };
  const tileBadges = memoizeTileData(
    getPlpTileBadges,
    { ...commonCacheKeys, key: 'badges' },
    {
      tileData,
      categoryName,
      bestSellerBadgeLabel,
      topRatedBadgeLabel,
    }
  );
  const { topBadge, merchantTag } = tileBadges;
  const apiConfig = getAPIConfig();
  const { brandId: primaryBrand, siteId } = apiConfig;
  const isBundle = isBundleProduct(tileData);
  const { pdpUrl } = getPdpUrl({ seoToken, siteId, productPartNo, isBundleProduct: isBundle });
  const TCPSwatches = siteId === 'us' ? TCPSwatchesUSStore : TCPSwatchesCanadaStore;
  const brand = memoizeTileData(
    getPlpProductBrand,
    { ...commonCacheKeys, key: 'brand' },
    tileData,
    primaryBrand
  ); // evaluates item brand
  const { assetHost, assetPath } = getImageAssetConfig(brand, apiConfig);
  const assetHostBaseUrl = extractBaseUrl(assetHost);
  const influencerTags = getInfluencerTags(tileData);
  const { imageUrl, itemAvailability, isVideoUrl, fullImageUrl, overlayBadgeParams } = getImageData(
    {
      stylePartNo,
      productPartNo,
      assetPath,
      imageName,
      altImage,
      isShortImage,
      primaryBrand,
      assetHostBaseUrl,
      ...styleTypeQty,
    }
  );
  const isHardMarkDown = tileData?.is_hard_mark_enable;
  const isHideOriginalPrice = hideProductOriginalPrice(
    isHardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );
  const { colorSwatchList } = getColorSwatchList({
    productPartNo,
    TCPSwatches,
    assetHost,
    assetPath,
    swatchImg,
    relatedSwatchImages,
    tcpColor,
    isNewSwatchUrlEnabled,
  });

  const colorSwatchClass = addToBagIconInPLP ? 'atb-btn-class' : '';

  const { ratings, reviewCount } = getReviewRatingsData({
    TCPBazaarVoiceRating,
    TCPBazaarVoiceReviewCount,
  });

  const emptyRRColorSwatchesClass =
    colorSwatchList?.length < 2 && ratings < 1 ? 'empty' : 'non-empty';

  const colorSwatch = colorSwatchCls(isTileRedesignAB);

  const collectProductDataOnClick = () => {
    return getProductDataForPdp({
      topBadge,
      styleTypeQty,
      primaryBrand: brand,
      isShortImage,
      productImageUrl: imageUrl,
      tileData,
      downloadedImage: fullImageUrl,
      merchantTag,
      isBundle,
      promotionsData,
      TCPSwatches,
    });
  };
  useEffect(() => {
    if (isSyteEnabled) setShowDiscoveryIcon(true);
  }, [isSyteEnabled]);
  const setProductDataForPdp = () => {
    const pdpData = collectProductDataOnClick();
    saveProductDataForPdp(pdpData);
    pushEventToAdobeAnalytics('product_click', pdpData);
  };

  const saveDataForQv = () => {
    const quickViewData = collectProductDataOnClick();
    saveProductDataForQV(quickViewData);
    pushEventToAdobeAnalytics('product_quick_view', quickViewData);
  };

  const handleViewBundleClick = () => {
    const { href, asPathWithoutSlug } = pdpUrl;
    routerPush(href, asPathWithoutSlug);
  };

  const handleClick = async () => {
    requestAnimationFrame(async () => {
      await AddedtoBagDynamicStore();
      if (isBundle) {
        setProductDataForPdp();
        handleViewBundleClick();
      } else {
        const hasTriggeredOneClickATC = triggerOneClickATC({
          tileData,
          isOneClickATCEnabled,
          isBopisFilterOn: false,
          topBadge,
          brand,
          imageUrl,
          addToBagEcom,
        });
        if (!hasTriggeredOneClickATC) {
          saveDataForQv();
          onQuickViewOpenClick({
            colorProductId: productPartNo,
            fromPage: 'PLP',
            fromPageBranch: 'HPLP',
          });
          QVEcommerceCall({
            tileData,
            isTopRatedBackAbEnabled,
            isBestSellerBackAbEnabled,
            tileBadges,
          });
        }
      }
    });
  };

  let addToBagButtonText = submitButtonText;
  if (isBundle && submitButtonText !== pickupInStore) {
    if (primaryBrand === 'GYM') {
      addToBagButtonText = shopTheLook;
    } else {
      addToBagButtonText = shopCollection;
    }
  }

  const SyteConfig = {
    image: `${getAssetHostURL()}/${imageUrl}`,
    sku: productPartNo,
    placement: 'PLP',
    clickAnalytics: trackAnalyticsClick,
  };

  const renderColorSwatches = (flag) => {
    if ((isTileRedesignAB && flag) || (!isTileRedesignAB && !flag) || !hasMounted) {
      return (
        <ColorSwatchesHlp
          colorSwatchList={colorSwatchList}
          onQuickViewOpenClick={onQuickViewOpenClick}
          saveDataForQv={saveDataForQv}
          isBundleProduct={isBundle}
          handleViewBundleClick={handleViewBundleClick}
          isTileRedesignAB={isMountedTileRedesignAB}
        />
      );
    }
    return '';
  };

  return (
    <PlpTile data-prodId={productPartNo} className={`${className} ${customClass}`}>
      <>
        <ProductImage
          itemAvailability={itemAvailability}
          fullImageUrl={fullImageUrl}
          pdpUrl={pdpUrl}
          productName={productName}
          isVideoUrl={isVideoUrl}
          pathName={pathName}
          setProductDataForPdp={setProductDataForPdp}
          imageUrl={imageUrl}
          assetHostBaseUrl={assetHostBaseUrl}
          overlayBadgeParams={overlayBadgeParams}
          topRatedBadge={!isTopRatedBackAbEnabled && tileBadges?.topRatedBadge}
          bestSellerBadge={!isBestSellerBackAbEnabled && tileBadges?.bestSellerBadge}
          preloadImage={preloadImage}
        />
        <InfluencerBadgeHandle
          isAbOn={isInfluencerBadgeEnabled}
          influencerTags={influencerTags}
          image={imageName}
          isPreviewImage
        />
      </>
      <ColorSwatchWrapper hplp isTileRedesignAB={isTileRedesignAB}>
        <div
          className={`rr-colorswatch ${colorSwatchClass}  ${emptyRRColorSwatchesClass} ${colorSwatch}`}
        >
          {renderColorSwatches(true)}
        </div>
      </ColorSwatchWrapper>
      {showDiscoveryIcon && !isShopThisStoreModeOn() && (
        <div className="syte-container-wrapper">
          <DiscoveryButton config={SyteConfig}>
            <AnimatedSearchIcon
              iconLabel={shopSimilarLabel}
              iconPath={getIconPath('cta-search')}
              reverseOrder
            />
          </DiscoveryButton>
        </div>
      )}
      <Divider isTileRedesignAB={isMountedTileRedesignAB} height={16} />
      <PriceAndWishList
        minListPrice={minListPrice}
        minOfferPrice={minOfferPrice}
        lowOfferPrice={lowOfferPrice}
        highOfferPrice={highOfferPrice}
        lowListPrice={lowListPrice}
        highListPrice={highListPrice}
        productPartNo={productPartNo}
        merchantTag={merchantTag}
        wishListData={wishListData}
        onAddItemToFavorites={onAddItemToFavorites}
        onSetLastDeletedItemIdAction={onSetLastDeletedItemIdAction}
        primaryBrand={primaryBrand}
        isHideOriginalPrice={isHideOriginalPrice}
        trackWishListClick={trackWishListClick}
        isLoggedIn={isLoggedIn}
        isBundle={isBundle}
        isHlpTile
      />
      <ProductTitleHlp
        itemAvailability={itemAvailability}
        productName={productName}
        brand={brand}
        primaryBrand={primaryBrand}
        pdpUrl={pdpUrl}
        pathName={pathName}
        setProductDataForPdp={setProductDataForPdp}
        isHlpTile
        isTileRedesignAB={isMountedTileRedesignAB}
      />
      <div className={`rr-colorswatch ${colorSwatchClass}  ${emptyRRColorSwatchesClass}`}>
        {hasMounted && renderColorSwatches(false)}
        <ReviewAndratingsHlp
          isTileRedesignAB={isMountedTileRedesignAB}
          ratings={ratings}
          reviewCount={reviewCount}
        />
      </div>

      {hasMounted && addToBagIconInPLP ? (
        <div>
          <AtbIcon onClick={handleClick} isHlp>
            <img src={getIconPath('add-to-bag')} alt="Add to bag" />
          </AtbIcon>
        </div>
      ) : (
        <div className="with-btn-class">
          <SubmitButton brand={primaryBrand} isBundleProduct={isBundle} onClick={handleClick} isHlp>
            {addToBagButtonText}
          </SubmitButton>
        </div>
      )}
    </PlpTile>
  );
}

HlpTileView.propTypes = {
  className: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  tileData: PropTypes.shape({
    TCPBazaarVoiceRating: PropTypes.number,
    TCPBazaarVoiceReviewCount: PropTypes.number,
    TCPSwatchesUSStore: PropTypes.string,
    TCPSwatchesCanadaStore: PropTypes.string,
    prodpartno: PropTypes.string,
    product_name: PropTypes.string,
    seo_token: PropTypes.string,
    min_offer_price: PropTypes.number,
    min_list_price: PropTypes.number,
    style_partno: PropTypes.string,
    productimage: PropTypes.string,
    alt_img: PropTypes.string,
    TCPStyleQTYCA: PropTypes.string,
    TCPStyleQTYUS: PropTypes.string,
    TCPStyleTypeCA: PropTypes.string,
    TCPStyleTypeUS: PropTypes.string,
    TCPColor: PropTypes.string,
  }),
  tileActions: PropTypes.shape({
    onQuickViewOpenClick: PropTypes.func,
    onAddItemToFavorites: PropTypes.func,
    onSetLastDeletedItemIdAction: PropTypes.func,
  }).isRequired,
  submitButtonText: PropTypes.string.isRequired,
  wishListData: PropTypes.shape({}),
  isShortImage: PropTypes.bool.isRequired,
  saveProductDataForPdp: PropTypes.func,
  categoryName: PropTypes.string,
  isTopRatedBackAbEnabled: PropTypes.bool.isRequired,
  isBestSellerBackAbEnabled: PropTypes.bool.isRequired,
  isSyteEnabled: PropTypes.bool.isRequired,
  trackAnalyticsClick: PropTypes.func,
  addToBagIconInPLP: PropTypes.bool.isRequired,
  isNewSwatchUrlEnabled: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
  promotionsData: PropTypes.shape({}),
};
HlpTileView.defaultProps = {
  customClass: '',
  wishListData: null,
  tileData: null,
  categoryName: '',
  trackAnalyticsClick: () => {},
  isNewSwatchUrlEnabled: false,
  isOneClickATCEnabled: false,
  addToBagEcom: () => {},
  promotionsData: {},
};
export { HlpTileView as HlpTileViewVanilla };
export default withStyles(HlpTileView, style);
